import { useEffect, useState } from "react";
import axios from "axios";
import Reveal from "@/components/Reveal";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const FALLBACK = "https://images.unsplash.com/photo-1579975096649-e773152b04cb?q=80&w=1400&auto=format&fit=crop";

const Pastor = () => {
  const [photo, setPhoto] = useState(null);

  useEffect(() => {
    axios
      .get(`${API}/gallery`)
      .then(({ data }) => {
        const p = data.find((x) => x.caption === "Nuestro pastor");
        if (p) setPhoto(`${BACKEND_URL}${p.url}`);
      })
      .catch(() => {});
  }, []);

  return (
    <section id="pastor" className="relative overflow-hidden border-t border-white/10 bg-surface py-28 lg:py-36" data-testid="pastor-section">
      <div className="relative mx-auto max-w-[1600px] px-6 lg:px-12">
        <div className="grid items-center gap-14 lg:grid-cols-12">
          <div className="lg:col-span-5">
            <Reveal className="relative">
              <div className="absolute -inset-4 bg-fire/15 blur-3xl" aria-hidden="true" />
              <figure className="relative border border-white/10">
                <img
                  src={photo || FALLBACK}
                  alt="Ps. Abiud Gutiérrez Mora, pastor de la Iglesia Viento de Gracia"
                  loading="lazy"
                  className="aspect-[4/5] w-full object-cover"
                  data-testid="pastor-img"
                />
                <figcaption className="absolute bottom-0 left-0 w-full bg-gradient-to-t from-ink/90 to-transparent p-6 text-[10px] font-light uppercase leading-relaxed tracking-[0.3em] text-paper/70">
                  Ps. Abiud Gutiérrez Mora · Viento de Gracia
                </figcaption>
              </figure>
            </Reveal>
          </div>

          <div className="lg:col-span-6 lg:col-start-7">
            <Reveal>
              <p className="mb-8 flex items-center gap-4 text-[10px] font-light uppercase tracking-[0.5em] text-fire" data-testid="pastor-eyebrow">
                <span className="inline-block h-px w-16 bg-fire" /> Conoce al pastor
              </p>
            </Reveal>
            <Reveal delay={0.1}>
              <p className="font-sans text-xl font-normal leading-relaxed text-paper/90 sm:text-2xl sm:leading-relaxed" data-testid="pastor-carta">
                <span className="mr-3 font-serif text-6xl leading-none text-fire">«</span>
                Si estás leyendo esto, no es casualidad. Mi esposa Milena y yo llevamos años
                viendo cómo Dios transforma vidas comunes en historias extraordinarias, y queremos
                que sepas algo: aquí no necesitas tener la vida resuelta para entrar. Ven tal como
                eres — con tus dudas, tu cansancio, tu historia. En Viento de Gracia encontrarás
                una familia que ora por ti desde antes de conocerte.
                <span className="ml-3 font-serif text-6xl leading-none text-fire">»</span>
              </p>
            </Reveal>
            <Reveal delay={0.2}>
              <div className="mt-10 border-t border-white/10 pt-6">
                <p className="font-serif text-2xl italic text-gold" data-testid="pastor-firma">Ps. Abiud Gutiérrez Mora</p>
                <p className="mt-1 text-[10px] font-light uppercase tracking-[0.3em] text-smoke" data-testid="pastor-firma-esposa">
                  junto a la Ps. Milena Sales · Iglesia Cristiana Viento de Gracia · Toluca
                </p>
              </div>
            </Reveal>
            <Reveal delay={0.3}>
              <a
                href="#contacto"
                onClick={(e) => { e.preventDefault(); window.__lenis?.scrollTo("#contacto", { offset: -60 }); }}
                data-testid="pastor-contacto-btn"
                className="mt-10 inline-flex items-center gap-3 border border-paper/30 px-8 py-4 text-[11px] font-medium uppercase tracking-[0.3em] text-paper transition-colors duration-300 hover:border-paper hover:bg-paper hover:text-ink"
              >
                Escríbenos, te esperamos
              </a>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Pastor;
